import * as DechargementsActions from './../actions/dechargements.actions';
import { IReception } from './../../interfaces/models';

export type Action = DechargementsActions.All;

// Reducer function
export function dechargementsReducer(data: IReception[] = [], action: Action) {
  switch (action.type) {
    case DechargementsActions.SET: {
      return action.data;
    }
    case DechargementsActions.EDIT: {
      data.forEach((c: IReception, index) => {
        if (c.id === action.data.id) {
          data[index] = action.data;
        }
      });

      return [...data];
    }
    case DechargementsActions.ADD: {
      return [action.data, ...data];
    }
    case DechargementsActions.DELETE: {
      const newData = data.filter((c: IReception) => {
        return c.id !== action.id;
      });
      return newData;
    }
    case DechargementsActions.OPEN_MODAL: {
      return true;
    }
    case DechargementsActions.CLOSE_MODAL: {
      return false;
    }
    default: {
      return data;
    }
  }
}
